/**
 * Export `advisorMarketTypes`.
 */

export const advisorMarketTypes = {
  helium: 'helium',
  lpg: 'lpg',
  packagedChemicals: 'packaged_chemicals',
  refrigerants: 'refrigerants',
  scba: 'scba'
};

/**
 * Export `AdvisorMarketType` type.
 */

export type AdvisorMarketType = keyof typeof advisorMarketTypes;

/**
 * Export `marketsWithoutButanePropane`.
 */

export const marketsWithoutButanePropane = [
  advisorMarketTypes.packagedChemicals,
  advisorMarketTypes.refrigerants
];

/**
 * Export `Market` type.
 */

export type Market = {
  advisorMarketType: AdvisorMarketType;
  bgColor: string;
  description: string;
  featuredImage: string;
  id: string;
  slug: string;
  title: string;
};
